import { Component } from '@angular/core';
import { trackById } from 'src/app/core/utils/track-by';

@Component({
  selector: 'app-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.css'],
  standalone: false,
})
export class LandingPageComponent {
  trackById = trackById;
  platformList = [
    {
      img: 'assets/images/onboarding/ic_tpm.svg',
      title: 'TPM Portal',
    },
    {
      img: 'assets/images/onboarding/ic_pos.svg',
      title: 'POS',
    },
    // {
    //   img: 'assets/images/onboarding/ic_donation.svg',
    //   title: 'Donation',
    // },
    {
      img: 'assets/images/onboarding/ic_lister.svg',
      title: 'Lister',
    },
  ];
}
